import {alpha, createTheme} from '@mui/material/styles';

export const createAppTheme = (
    primaryColor = '#2563EB',
    accentColor = '#06B6D4',
    companyName = 'BusiFarm',
    darkMode = false,
) => createTheme({
    palette: {
        mode: darkMode ? 'dark' : 'light',
        primary: {
            main: primaryColor,
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#1E293B',
            contrastText: '#FFFFFF',
        },
        success: {
            main: '#10B981',
        },
        warning: {
            main: '#F59E0B',
        },
        error: {
            main: '#EF4444',
        },
        info: {
            main: accentColor,
        },
        background: {
            default: darkMode ? '#0F172A' : '#F8FAFC',
            paper: darkMode ? '#111827' : '#FFFFFF',
        },
        text: {
            primary: darkMode ? '#F8FAFC' : '#0F172A',
            secondary: darkMode ? '#CBD5E1' : '#64748B',
        },
        divider: darkMode ? '#1F2937' : '#E2E8F0',
    },
    shape: {
        borderRadius: 16,
    },
    typography: {
        fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        h3: {fontWeight: 700, letterSpacing: '-0.02em'},
        h4: {fontWeight: 700, letterSpacing: '-0.02em'},
        h5: {fontWeight: 700, letterSpacing: '-0.02em'},
        h6: {fontWeight: 700},
        button: {textTransform: 'none', fontWeight: 600},
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: darkMode ? '#0F172A' : '#F8FAFC',
                    color: darkMode ? '#F8FAFC' : '#0F172A',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    minHeight: 42,
                    borderRadius: 12,
                    paddingInline: 18,
                    boxShadow: 'none',
                },
                containedPrimary: {
                    '&:hover': {
                        boxShadow: '0 12px 24px rgba(37,99,235,0.16)',
                    },
                },
                outlined: {
                    borderColor: darkMode ? '#334155' : '#E2E8F0',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 18,
                    border: `1px solid ${darkMode ? '#1F2937' : '#E2E8F0'}`,
                    boxShadow: '0 1px 2px rgba(15,23,42,0.04)',
                    backgroundImage: 'none',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                rounded: {
                    borderRadius: 18,
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 14,
                    backgroundColor: darkMode ? '#111827' : '#FFFFFF',
                    '& fieldset': {
                        borderColor: darkMode ? '#334155' : '#E2E8F0',
                    },
                    '&:hover fieldset': {
                        borderColor: darkMode ? '#475569' : '#CBD5E1',
                    },
                },
                input: {
                    paddingTop: 13,
                    paddingBottom: 13,
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderColor: darkMode ? '#1F2937' : '#E2E8F0',
                },
                head: {
                    fontWeight: 700,
                    color: darkMode ? '#CBD5E1' : '#64748B',
                    fontSize: 13,
                    backgroundColor: darkMode ? alpha('#FFFFFF', 0.02) : alpha('#F8FAFC', 0.9),
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 10,
                    fontWeight: 600,
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    '&.Mui-selected': {
                        backgroundColor: primaryColor,
                        color: '#FFFFFF',
                        boxShadow: '0 10px 25px rgba(37,99,235,0.18)',
                        '&:hover': {
                            backgroundColor: primaryColor,
                        },
                    },
                    '&:hover': {
                        backgroundColor: darkMode ? alpha('#FFFFFF', 0.04) : '#F1F5F9',
                    },
                },
            },
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    borderRadius: 999,
                    backgroundColor: darkMode ? alpha('#FFFFFF', 0.08) : '#E2E8F0',
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 20,
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    borderRadius: 16,
                    border: `1px solid ${darkMode ? '#1F2937' : '#E2E8F0'}`,
                    boxShadow: '0 18px 40px rgba(15,23,42,0.12)',
                    minWidth: 180,
                },
            },
        },
    },
});
